<template>
    <div class="main-index">
        <div class="main-content">
            <div class="main-left-right">
                <div class="main-left main_bgColor" style="height: 35%;">
                    <div class="main_title">碳中和</div>
                    <div class="first_div">
                        <div class="first_line">
                            <div class="first_title">实时数据 &nbsp;&nbsp;&nbsp;{{ time }}</div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first1.png" />
                                <div>实时能耗量</div>
                                <div><i>{{ tzhData.active_power }}</i>万kWh</div>
                            </div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first2.png" />
                                <div>实时标煤量</div>
                                <div><i>{{ tzhData.tce_power }}</i>吨</div>
                            </div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first3.png" />
                                <div>实时碳排放耗量</div>
                                <div><i>{{ tzhData.tpf_power }}</i>吨</div>
                            </div>
                        </div>
                        <div class="first_line">
                            <div class="first_title">当年数据(2023年6月以后光伏接入后的数据统计)</div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first4.png" />
                                <div>碳排放量</div>
                                <div><i>{{ tzhData.total_tpf_power }}</i>吨</div>
                            </div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first5.png" />
                                <div>碳减放量</div>
                                <div><i>{{ tzhData.total_tjp_power }}</i>吨</div>
                            </div>
                            <div class="first_column_cnt">
                                <img src="../../../assets/image/mainIndex/first6.png" />
                                <div>减排率</div>
                                <div><i>{{ tzhData.total_rate }}</i>%</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="main_left_cnt">
                        <div class="tanzhonghe">
                            <div class="tzh_div">碳排放量</div>
                            <div class="tzh_div"><i>7488</i>吨</div>
                        </div>
                        <div class="tanzhonghe">
                            <div class="tzh_div">碳减排量</div>
                            <div class="tzh_div"><i>2080</i>吨</div>
                        </div>
                        <div class="tanzhonghe">
                            <div class="tzh_div">减排率</div>
                            <div class="tzh_div"><i>27</i>%</div>
                        </div>
                    </div> -->
                </div>
                <div class="main-left main_bgColor" style="height: 25%;">
                    <div class="main_title">近6个月整体用电情况</div>
                    <!-- <div class="cdl_select">
                        <div :class="[yd_type == 1 ? 'title_s cdl_title' : 'title_us cdl_title']" @click="yd_click(1)">电</div>
                        <div :class="[yd_type == 2 ? 'title_s cdl_title' : 'title_us cdl_title']" style="margin-left: 0.5rem;"  @click="yd_click(2)">水</div>
                        <div :class="[yd_type == 3 ? 'title_s cdl_title' : 'title_us cdl_title']" style="margin-left: 0.5rem;"  @click="yd_click(3)">天然气</div>
                    </div> -->
                    <div class="main_left_cnt" style="height: 100% !important">
                        <v-chart :auto-resize="true" :options="firstBar" ref="firstBar" theme="ovilia-green" />
                    </div>
                </div>
                <div class="main-left main_left2 main_bgColor">
                    <div class="main_title">变压器负载率</div>
                    <div class="main_left_cnt">
                        <div class="main_left_byq">
                            <div style="top: 0%;left: 8%;">#1分配 #1变902&nbsp;<i>{{ realTransformerData['1628c53175a14c1094657e5fbe683aad'].transformer_rate }}%</i></div>
                            <div style="top: 30%;left: 4%;">#1分配 #4变905&nbsp;<i>{{ realTransformerData['191e37f359a942f9862aba87d02221d9'].transformer_rate }}%</i></div>
                            <div style="top: 60%;left: 5%;">#2分配电室901&nbsp;<i>{{ realTransformerData['9f8cac3bec214a8e9ceca5419d556cc3'].transformer_rate }}%</i></div>
                            <div style="top: 0%;left: 65%;">#2分配电室901*&nbsp;<i>{{ realTransformerData['6e50a6f36936476781e24cb984197adf'].transformer_rate }}%</i></div>
                            <div style="top: 30%;left: 66%;">#1分配 #2变903&nbsp;<i>{{ realTransformerData['910e4da63a0a40d9afe08338bfa7d68d'].transformer_rate }}%</i></div>
                            <div style="top: 60%;left: 66%;">#1分配 #3变904&nbsp;<i>{{ realTransformerData['9d97ed0be11c4b348a5364a9dadbf1de'].transformer_rate }}%</i></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main_center">
                <div class="center_both">
                    <div class="center_nav center_nav1">
                        <div :class="[tyType == 1 ? 'center_nav_item center_nav_s center_nav_item1' : 'center_nav_item center_nav_ns center_nav_item1']" @click="clickTj(1)">
                            <img src="../../../assets/image/mainIndex/center_year.png" />
                            年数据统计
                        </div>
                        <div :class="[tyType == 2 ? 'center_nav_item center_nav_s center_nav_item1' : 'center_nav_item center_nav_ns center_nav_item1']" @click="clickTj(2)">
                            <img src="../../../assets/image/mainIndex/center_month.png" />
                            月数据统计
                        </div>
                        <div :class="[tyType == 3 ? 'center_nav_item center_nav_s center_nav_item1' : 'center_nav_item center_nav_ns center_nav_item1']" @click="clickTj(3)">
                            <img src="../../../assets/image/mainIndex/center_day.png" />
                            日数据统计
                        </div>
                    </div>
                    <div class="center_chart">
                        <div class="center_chart_item">
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/shang1.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{ powerData && powerData.fd_power }}</i>&nbsp;kWh</div>
                                    <div><i>发电量</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/shang2.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{ powerData && powerData.sw_power }}</i>&nbsp;kWh</div>
                                    <div><i>上网电量</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/shang3.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{ powerData && powerData.xn_rate }}</i>&nbsp;%</div>
                                    <div><i>消纳率</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/shang4.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{ powerData && powerData.xn_power }}</i>&nbsp;kWh</div>
                                    <div><i>消纳量</i></div>
                                </div>
                            </div>
                        </div>
                        <div class="center_chart_item">
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/xia1.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[4]}}</i>&nbsp;kWh</div>
                                    <div><i>储能调峰电量</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/xia2.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[5]}}</i>&nbsp;次</div>
                                    <div><i>储能充放次数</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/xia3.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[6]}}</i>&nbsp;kWh</div>
                                    <div><i>充电桩充电量</i></div>
                                </div>
                            </div>
                            <div class="center_item_div">
                                <img src="../../../assets/image/mainIndex/xia4.png" />
                                <div class="center_item_cnt">
                                    <div><i>{{tjData[7]}}</i>&nbsp;次</div>
                                    <div><i>充电桩充电次数</i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="center_both main_bgColor">
                    <div class="main_title" style="width: 40%">发电量对比</div>
                    <div class="center_nav center_nav2">
                        <div class="center_nav_item center_nav_ns center_nav_item2">
                            <img src="../../../assets/image/mainIndex/fdl_xia2.png" />
                            <div class="item2_div">
                                <div>今年</div>
                                <div><i>{{ fdlData.year_bq_power }}</i>&nbsp;万kWh</div>
                            </div>
                        </div>
                        <div class="center_nav_item center_nav_ns center_nav_item2">
                            <img src="../../../assets/image/mainIndex/fdl_xia1.png" />
                            <div class="item2_div">
                                <div>去年</div>
                                <div><i>{{ fdlData.year_tq_power }}</i>&nbsp;万kWh</div>
                            </div>
                        </div>
                        <div class="center_nav_item center_nav_ns center_nav_item2">
                            <img src="../../../assets/image/mainIndex/fdl_xia3.png" />
                            <div class="item2_div">
                                <div>增长率</div>
                                <div><i>{{ fdlData.year_growth_rate }}</i>%</div>
                            </div>
                        </div>
                    </div>
                    <div class="center_chart">
                        <v-chart :auto-resize="true" :options="centerBar" ref="centerBar" theme="ovilia-green" />
                    </div>
                </div>
            </div>
            <div class="main-left-right">
                <div>
                    <el-form
                        :model="searchForm1"
                        ref="searchForm1"
                        class="leader-style-form"
                    >
                    <el-form-item label="年份" style="width: 80%">
                        <el-date-picker
                            v-model="searchForm1.time"
                            align="right"
                            type="year"
                            placeholder="选择年"
                            value-format="yyyy"
                            format="yyyy"
                            :picker-options="disableDate"
                            :clearable="false"
                            :editable="false"
                        ></el-date-picker>
                        <el-button
                            class="leader-common-button"
                            size="medium"
                            @click="handleSearchReport"
                            >查询</el-button
                        >
                    </el-form-item>
                </el-form>
                </div>
                <div class="main-left main_bgColor" style="height: calc(28% - 2.2rem)">
                    <div class="main_title">各部门电量电比</div>
                    <!-- <div class="main_left_cnt cdz_pad" style="height: fit-content">
                        <div class="cdz_div">
                            <img src="../../../assets/image/mainIndex/cdz1.png" />
                            <div class="cdz_div_cnt">
                                <div>正在充电（个）</div>
                                <div><i>10/10</i></div>
                            </div>
                        </div>
                        <div class="cdz_div">
                            <img src="../../../assets/image/mainIndex/cdz1.png" />
                            <div class="cdz_div_cnt">
                                <div>本月月充电次数</div>
                                <div><i>198</i>&nbsp;次</div>
                            </div>
                        </div>
                    </div> -->
                    <div class="main_left_cnt">
                        <v-chart auto-resize :options="pieDepartment" ref="pieDepartment" theme="ovilia-green" />
                    </div>
                </div>
                <div class="main-left main_bgColor" style="height: 33%;">
                    <div class="main_title">各部门每月用电量统计</div>
                    <!-- <div class="cdl_select">
                        <div :class="[cdl_type == 1 ? 'title_s cdl_title' : 'title_us cdl_title']" @click="cdl_click(1)">9L1</div>
                        <div :class="[cdl_type == 2 ? 'title_s cdl_title' : 'title_us cdl_title']" style="margin-left: 0.5rem;"  @click="cdl_click(2)">9L2</div>
                    </div>
                    <div class="main_left_cnt" style="height: calc(100% - 4rem) !important">
                        <v-chart auto-resize :options="areaLine" ref="chart" theme="ovilia-green" />
                    </div> -->
                    <div class="main_left_cnt">
                        <v-chart auto-resize :options="barDepartment" ref="barDepartment" theme="ovilia-green" />
                    </div>
                </div>
                <div class="main-left main_left4 main_bgColor">
                    <div class="main_title">各部门数据对比</div>
                    <el-form
                        :model="searchForm"
                        ref="searchForm"
                        class="leader-style-form"
                        style="margin-top: 1rem;"
                    >
                        <el-select v-model="searchForm.elecDept" @change="changeElecDept" style="width: 90%;">
                            <el-option
                                v-for="item in deptList"
                                :key="item.tree_unit_id"
                                :label="item.tree_unit_name"
                                :value="item.tree_unit_id"
                            ></el-option>
                        </el-select>
                    </el-form>
                    <div class="main_left_cnt" style="height: calc(100% - 2.4rem) !important; margin-top: 0 !important">
                        <v-chart :auto-resize="true" :options="lastBar" ref="lastBar" theme="ovilia-green" />
                        <!-- <div class="bz_div"><i>储能的充放电次数:</i>121<i>次</i></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import * as api from "@/http/api.js";
import moment from "moment";
import utils from "@/utils/utils";
export default {
    data() {
        return {
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysdate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            searchForm: {
                elecDept: ''
            },
            searchForm1: {
                time: moment().format('YYYY')
            },
            cdl_type: 1,
            yd_type: 1,
            light_y: [],
            last_line_y: [],
            first_y: [],
            first_y1: ['105', '85', '135', '120', '105'],
            first_y2: ['120', '105', '105', '135', '85'],
            first_y3: ['85', '135', '120', '105', '105'],
            tyType: 1, //1年数据统计 2月数据统计 3日数据统计
            tyData: [],
            tjYearData: ['400万', '12万', '97', '388万','4.27万','730','15万','2008'],
            tjMonthData: ['33万', '9000', '97.3', '32.1万','1.1万','60','1.05万','212'],
            tjDayData: ['1万', '280', '97.2', '9720','391','2','528','11'],
            cdl_list: [],
            cdl_list1: [6000, 7000, 10000, 9000, 8000, 6000, 8000, 3000, 4000],
            cdl_list2: [4000, 3000, 8000, 6000, 8000, 8000, 10000, 7000, 6000],
            time: '',
            tzhData: {},
            realMonthData: {},
            realTransformerData: {},
            fdlData: {},
            powerDataBasic: {},
            powerData: {},
            deptElecData: [],
            deptElecData_x: [],
            monthDeptPowerData: [],
            dept_growth_rate_list: [],
            dept_x_list: [],
            dept_tq_list: [],
            dept_bq_list: [],
        };
    },
    created() {
        this.initData();
        // this.getSysDate();
    },
    methods: {
        initData() {
            this.getRealCarbon();
            this.getRealMonthData();
            this.getRealTransformerData();
            
            this.light_y = this.getRandom(12);
            this.ping_y = this.getRandom(12);
            this.gu_y = this.getRandom(12);
            this.last_line_y = this.getRandom(12);
            this.first_y = this.first_y1;
            this.tjData = this.tjYearData;
            this.cdl_list = this.cdl_list1;
            this.time = moment().format('YYYY-MM-DD');
            this.getPowerComparison();
            this.getRealTimeGfPower();
            this.getDeptPowerComparison();
            this.getMonthDeptPowerComparison();
            this.getIndexDeptList();
        },
        getSingleDeptPowerComparison() {
            api.getSingleDeptPowerComparison({ tree_unit_id: this.searchForm.elecDept }).then(res => {
                if (res && res.error_code == 0) {
                    this.dept_growth_rate_list = res.bus_json.growth_rate_list;
                    this.dept_x_list = res.bus_json.time_list;
                    this.dept_tq_list = res.bus_json.tq_list;
                    this.dept_bq_list = res.bus_json.bq_list;
                }
            });
        },
        getIndexDeptList() {
            api.getIndexDeptList().then(res => {
                if (res && res.error_code == 0) {
                    this.deptList = res.bus_json;
                    if(this.deptList && this.deptList.length) {
                        this.searchForm.elecDept = this.deptList[0].tree_unit_id;
                        this.getSingleDeptPowerComparison();
                    }
                }
            });
        },
        getMonthDeptPowerComparison() {
            api.getMonthDeptPowerComparison({show_year: this.searchForm1.time}).then(res => {
                if (res && res.error_code == 0) {
                    this.monthDeptPowerData = res.bus_json;
                    const series = [];
                    this.monthDeptPowerData && this.monthDeptPowerData.legend && this.monthDeptPowerData.legend.forEach((item, index) => {
                        series.push(
                            {
                                name: item,
                                type: "bar",
                                stack: "one",
                                barWidth: 10,
                                data: this.monthDeptPowerData.y_list[index],
                            },
                        )
                    })
                    this.monthDeptPowerData['series'] = series;
                }
            });
        },
        getDeptPowerComparison() {
            api.getDeptPowerComparison({show_year: this.searchForm1.time}).then(res => {
                if (res && res.error_code == 0) {
                    this.deptElecData = [];
                    this.deptElecData_x = res.bus_json.dept_name;
                    res.bus_json.dept_name && res.bus_json.dept_name.forEach((item, index)=> {
                        this.deptElecData.push({
                            name: item,
                            value: res.bus_json.active_power[index]
                        })
                    })
                }
            });
        },
        getPowerComparison() {
            api.getPowerComparison().then(res => {
                if (res && res.error_code == 0) {
                    this.fdlData = res.bus_json;
                }
            });
        },
        getRealTimeGfPower() {
            api.getRealTimeGfPower().then(res => {
                if (res) {
                    this.powerDataBasic = res.bus_json;
                    this.powerData = this.powerDataBasic && this.powerDataBasic.year;
                }
            });
        },
        getRealTransformerData() {
            api.getRealTransformerData().then(res => {
                if (res && res.error_code == 0) {
                    this.realTransformerData = res.bus_json;
                }
            });
        },
        getRealMonthData() {
            api.getRealMonthData({point_id: '000001'}).then(res => {
                if (res && res.error_code == 0) {
                    this.realMonthData = res.bus_json;
                }
            });
        },
        getRealCarbon() {
            api.getRealCarbon({point_id: '000001'}).then(res => {
                if (res && res.error_code == 0) {
                    this.tzhData = res.bus_json;
                }
            });
        },
        changeElecDept(e) {
            this.getSingleDeptPowerComparison();
        },
        handleSearchReport() {
            this.getDeptPowerComparison();
        },
        clickTj(type) {
            this.tyType = type;
            if(type == 1) {
                this.tjData = this.tjYearData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.year;
            }
            else if(type == 2) {
                this.tjData = this.tjMonthData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.month;
            }
            else {
                this.tjData = this.tjDayData;
                this.powerData = this.powerDataBasic && this.powerDataBasic.day;
            }
        },
        yd_click(type) {
            this.yd_type = type;
            if(type == 1) this.first_y = this.first_y1
            else if(type == 2) this.first_y = this.first_y2
            else this.first_y = this.first_y3
        },
        cdl_click(type) {
            this.cdl_type = type;
            if(type == 1) this.cdl_list = this.cdl_list1
            else this.cdl_list = this.cdl_list2
        },
        getRandom(num) {
            let arr = [];
            for (let i = 0; i < num; i++) {
                var random1 = (Math.random() * (150)).toFixed(2);
                arr.push(random1)
            }
            return arr;
        },
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code == 0) {
                    this.getCurrentElecList(res.bus_json.sysdate3);
                    this.getCurrentMonthsFdl(res.bus_json.sysdate3);
                }
            });
        },
    },
    computed: {
        areaLine() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    }
                },
                // legend: {
                //     orient: "horizontal",
                //     // icon: "circle",
                //     // top: 10,
                //     itemHeight: 10,
                //     itemWidth: 10,
                //     data: [
                //         {
                //             name: "充电量",
                //             textStyle: {
                //                 color: "#fff",
                //                 fontSize: 10
                //             }
                //         }
                //     ]
                // },
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "15%",
                    bottom: "5%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        data: ['2022-06', '2022-07', '2022-08', '2022-09', '2022-10', '2022-11', '2022-12', '2023-01', '2023-02']
                    }
                ],
                yAxis: [
                    {
                        name: "单位:kWh",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#999999" // 颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        nameTextStyle: {
                            color: "#999999",
                            //    padding: 10,
                            fontSize: 10
                        },
                         splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '充电量',
                        type: "line",
                        // name: this.quxian.legendData[0],
                        label: {
                            normal: {
                                show: false,
                                position: "top"
                            }
                        },
                        smooth: true,
                        symbolSize: 0.1,
                        itemStyle: {
                            normal: {
                                color: '#00c1de',
                                shadowBlur: 8,
                                shadowColor: '#25d5f0',
                                borderColor: '#00c1de',
                                borderWidth: 2,
                                backgroundColor: 'transparent'
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#00729B'
                                }, {
                                    offset: 1,
                                    color: '#0E7388'
                                }]),
                            }
                        },
                        data: this.cdl_list,
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'}
                            ]
                        }
                    }
                ]
            };
            return option;
        },
        lastBar() {
            const option = {
                grid: {
                    left: "5%",
                    right: "3%",
                    bottom: "10%",
                    top: "16%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                // legend: {
                //     orient: "horizontal",
                //     // icon: "circle",
                //     // top: 10,
                //     itemHeight: 10,
                //     itemWidth: 10,
                //     data: [
                //         {
                //             name: "去年",
                //             textStyle: {
                //                 color: "#fff",
                //                 fontSize: 10
                //             }
                //         },
                //         {
                //             name: "今年",
                //             textStyle: {
                //                 color: "#fff",
                //                 fontSize: 10
                //             }
                //         },
                //         {
                //             name: "增长率",
                //             textStyle: {
                //                 color: "#fff",
                //                 fontSize: 10
                //             }
                //         }
                //     ]
                // },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: this.dept_x_list,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位：kWh",
                        type: "value",
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    },
                    {
                        name: "单位：%",
                        type: "value",
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "去年",
                        type: "bar",
                        barWidth: 8,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        barGap: 0,
                        label: 111,
                        data: this.dept_tq_list,
                    },
                    {
                        name: "今年",
                        type: "bar",
                        barWidth: 8,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#8CCFA5'
                                }, {
                                    offset: 1,
                                    color: '#1F924A'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        label: 222,
                        data: this.dept_bq_list,
                    },
                    {
                        name: '增长率',
                        type: 'line',
                        yAxisIndex: 1,
                        itemStyle: {  /*设置折线颜色*/
                            normal: {
                                color: '#F8B551'
                            }
                        },
                        data: this.dept_growth_rate_list
                    }
                ]
            };
            return option;
        },
        centerBar() {
            const option = {
                grid: {
                    left: "1%",
                    right: "3%",
                    bottom: "10%",
                    top: "20%",
                    containLabel: true
                },
                color: ["#1593CE", "#CE720b"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                legend: {
                    orient: "horizontal",
                    // icon: "circle",
                    // top: 10,
                    itemHeight: 12,
                    itemWidth: 12,
                    data: [
                        {
                            name: "去年",
                            textStyle: {
                                color: "#fff",
                                fontSize: 12
                            }
                        },
                        {
                            name: "今年",
                            textStyle: {
                                color: "#fff",
                                fontSize: 12
                            }
                        },
                        {
                            name: "增长率",
                            textStyle: {
                                color: "#fff",
                                fontSize: 12
                            }
                        }
                    ]
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: { show: false },
                        data: this.fdlData.time_list,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位：万kWh",
                        type: "value",
                        // min:0,  //取0为最小刻度
                        // max: 90,
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    },
                    {
                        name: "单位：%",
                        type: "value",
                        // min:0,  //取0为最小刻度
                        // max: 18,
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "去年",
                        type: "bar",
                        barWidth: 10,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        barGap: 0,
                        data: this.fdlData.tq_power_list,
                    },
                    {
                        name: "今年",
                        type: "bar",
                        barWidth: 10,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#8CCFA5'
                                }, {
                                    offset: 1,
                                    color: '#1F924A'
                                }]),
                                barBorderRadius: [10, 10, 0, 0]
                            }
                        },
                        data: this.fdlData.bq_power_list
                    },
                    {
                        name: '增长率',
                        type: 'line',
                        yAxisIndex: 1,
                        itemStyle: {  /*设置折线颜色*/
                            normal: {
                                color: '#F8B551'
                            }
                        },

                        data: this.fdlData.growth_rate_list
                    }
                ]
            };
            return option;
        },
        firstBar() {
            const options = {
                // 坐标轴
                grid: {
                    top: "0%",
                    left: "5%",
                    right: "13%",
                    bottom: "7%",
                    containLabel: true, //是否包含坐标轴的文字
                },
                // X轴：横向柱状图，将xAxis的type设置为value
                xAxis: {
                    name: '万kWh',
                    type: "value",
                    nameTextStyle: {
                        color: "#fff",
                        fontSize: 10
                    },
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "" // 颜色
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "" // 颜色
                        }
                    }
                },
                // Y轴：横向柱状图，将xAxis的type设置为category
                yAxis: {
                    type: "category",
                    data: this.realMonthData.show_month,
                    nameTextStyle: {
                        color: "#fff",
                        fontSize: 10
                    },
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "" // 颜色
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "" // 颜色
                        }
                    }
                },
                // 图表内容
                series: [
                    {
                        type: "bar", // 图表类型
                        data: this.realMonthData.datalist, // 数据
                        barWidth: 8, // 柱的宽度
                        // 柱上面的数值配置
                        label: {
                            show: true, // 显示值
                            position: "right", // 显示位置
                            color: "white",
                            fontSize: 10
                        },
                        // 每一个条目的样式配置
                        itemStyle: {
                            barBorderRadius: [0, 34, 34, 0], // 圆角
                            // 渐变色  1、指明颜色渐变的方向  2、指明不同百分比之下颜色的值
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: "#1DA68C" },
                                { offset: 1, color: "#137EAA" },
                            ]),
                        },
                    },
                ],
            };
            return options;
        },
        barDepartment() {
            const options = {
                grid: {
                    left: "5%",
                    right: "3%",
                    bottom: "10%",
                    top: "32%",
                    containLabel: true
                },
                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.monthDeptPowerData && this.monthDeptPowerData.legend,
                    itemHeight: 10,
                    itemWidth: 10,
                    textStyle: {
                        color: utils.getFontColor(),
                        fontSize: 10,
                    }
                },
                color: ["#5afbf4", "#107e8c", "#0796d6", "#596376","#035465", "#013f56", "#1aada7", "#1f6781", "#5197a0", "#217398", "#427756"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "",
                        // axisLabel: {
                        //     rotate: -45,
                        // },
                        data: this.monthDeptPowerData && this.monthDeptPowerData.time_list,
                        // axisLabel: {
                        //     rotate: -45,
                        //     //y轴文字的配置
                        //     textStyle: {
                        //         color: utils.getFontColor()
                        //     }
                        // },
                        // axisLine: {
                        //     lineStyle: {
                        //         color: utils.getFontColor() // 颜色
                        //     }
                        // },
                        
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kWh",
                        nameTextStyle: {
                            color: "#999999",
                            fontSize: 10
                        },
                        // axisLabel: {
                        //     //y轴文字的配置
                        //     textStyle: {
                        //         color: utils.getFontColor()
                        //     }
                        // },
                        // axisLine: {
                        //     lineStyle: {
                        //         color: utils.getFontColor() // 颜色
                        //     }
                        // }
                        
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                series: this.monthDeptPowerData.series,
            };
            return options;
        },
        pieDepartment() {
            const option = {
                // title: {
                //     text: this.selectMonth + "月动能费用类型占比",
                //     left: "center",
                //     textStyle: {
                //         color: utils.getFontColor()
                //     }
                // },
                tooltip: {
                    trigger: "item"
                },
                color: ["#5afbf4", "#107e8c", "#0796d6", "#596376","#035465", "#013f56", "#1aada7", "#1f6781", "#5197a0", "#217398", "#427756"],
                legend: {
                    orient: "vertical",
                    right: "0%",
                    top: "center",
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: {
                        color: "#fff",
                        fontSize: 10,
                    },
                    data: this.deptElecData_x
                    // data: ["电"]
                },
                series: [
                    {
                        type: "pie",
                        selectedMode: "single",
                        radius: "80%",
                        center: ["25%", "50%"],
                        label: {
                            show: false,
                            position: "inner"
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.deptElecData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: utils.getFontColor()
                            }
                        }
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.main-index {
    width: 100%;
    height: calc(100% + #{px2Rem(45px)} + 5rem - 3.5rem);
    .leader-style-form {
        margin-bottom: 0 !important;
    }
    .leader-style-form .el-input__inner {
        height: 1.4rem !important;
        line-height: 1.4rem !important;
    }
    .el-input__icon {
        line-height: 1.4rem !important;
    }
    .leader-common-button {
        padding: 0.6rem !important;
        border-radius: 0.3rem !important;
        font-size: 0.7rem !important;
        height: auto !important;
    }
    .leader-style-form .el-form-item__label {
        font-size: 0.8rem !important;
    }
    .main-content {
        width: 100%;
        height: 100%;
        // background-image: url("../../../assets/image/mainIndex/back.png");
        // background-size: auto 80%;
        text-align: center;
        background-repeat: no-repeat;
        background-position: top center;
        padding: 0 1rem;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;

        .first_div {
            width: 100%; 
            margin-top: 4%;
            height: 46%;
            // display: flex; 
            // align-items:center;
            .first_line {
                width: 100%;
                height: 100%;
                display: inline-flex; 
                align-items: center;
                justify-content: space-between;
                position: relative;
                .first_title {
                    position: absolute;
                    top: 0;
                    left: 1rem;
                    height: 1.9rem;
                    width: 80%;
                    background: url("../../../assets/image/mainIndex/inner_title.png") no-repeat;
                    background-size: 100% 100%;
                    line-height: 1.9rem;
                    font-size: 0.65rem;
                    color: #fff;
                    text-align: left;
                    text-indent: 2.5rem;
                }
            }
            .first_column_cnt {
                display: inline-flex; 
                flex-flow: column wrap; 
                align-items:center;
                justify-content: space-around; 
                flex: 1;
                color: #fff;
                margin-top: 0.6rem;
                img {
                    width: 4rem;
                }
                div {
                    font-size: 0.65rem;
                    margin-top: 0.25rem;
                }
            }
        }
        .main-left-right {
            width: 23%;
            height: 100%;
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-between;
        }

        .main_center {
            width: 51%;
            display: inline-flex;
            flex-flow: column nowrap;
            justify-content: space-around;

            .center_both {
                height: 46%;
                display: inline-flex;
                flex-flow: row nowrap;
                position: relative;

                .center_nav2 {
                    width: 14%;
                    //    margin-right: 2%;

                    div {
                        font-size: 0.7rem;
                    }

                    img {
                        width: 1.5rem;
                        margin-left: 0.3rem;
                    }
                }

                .center_nav1 {
                    width: 18%;
                    margin-right: 2%;

                    img {
                        width: 1.5rem;
                        margin-right: 0.6rem;
                    }
                }

                .center_nav {
                    display: inline-flex;
                    flex-flow: column nowrap;
                    justify-content: space-around;

                    .center_nav_item {
                        color: #fff;
                        font-size: 0.8rem;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 0.6rem;
                        cursor: pointer;
                        .item2_div {
                            flex: 1;
                            display: inline-flex;
                            flex-flow: column nowrap;
                            height: 100%;
                            justify-content: space-evenly;
                        }
                    }
                    .center_nav_ns {
                        background: url("../../../assets/image/mainIndex/center_ns.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .center_nav_s {
                        background: url("../../../assets/image/mainIndex/center_s.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    .center_nav_item1 {
                        height: 15%;
                    }

                    .center_nav_item2 {
                        height: 12%;
                    }
                }

                .center_chart {
                    flex: 1;

                    .echarts {
                        width: 100%;
                        height: 100%;
                    }

                    .center_chart_item {
                        width: 100%;
                        height: 50%;
                        background: url("../../../assets/image/mainIndex/ban.png") no-repeat;
                        background-size: 100% auto;
                        background-position: bottom;
                        display: inline-flex;
                        flex-flow: row wrap;
                        justify-content: space-around;

                        .center_item_div {
                            width: 17%;
                            height: 80%;
                            position: relative;

                            img {
                                width: 100%;
                                height: 100%;
                            }

                            .center_item_cnt {
                                position: absolute;
                                bottom: 37%;
                                left: 0;
                                width: 80%;
                                margin: 0 10%;

                                div {
                                    width: 100%;
                                    color: #fff;
                                    height: 1.3rem;
                                    line-height: 1.3rem;
                                    font-size: 0.75rem;

                                    &:first-child i {
                                        font-size: 0.85rem;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .main_title {
            position: absolute;
            top: -1rem;
            left: 0;
            height: 2rem;
            width: 80%;
            background: url("../../../assets/image/mainIndex/main_title.png") no-repeat;
            background-size: 100% 100%;
            line-height: 2rem;
            font-size: 0.8rem;
            color: #fff;
            text-align: left;
            text-indent: 2rem;
        }

        .main_bgColor {
            background-color: rgb(7, 19, 19, 0.6);
        }

        .left-title {
            color: #fff;
            text-align: left;
            padding: 0.4rem 0 0 2.8rem;
            font-size: 0.8rem;
        }

        .right-title {
            color: #fff;
            text-align: right;
            padding: 0.4rem 2.8rem 0 0;
            font-size: 0.8rem;
        }

        .main_left1 {
            height: 20%;
        }

        .main_left2 {
            height: 31%;
        }

        .main_left3 {
            height: 25%;
        }

        .main_left4 {
            height: 31%;
        }

        .main-left {
            // height: 10rem;
            // background: url("../../../assets/image/mainIndex/l1.png") no-repeat;
            // background-size: 100% 100%;
            // margin-bottom: 1rem;
            width: 100%;
            position: relative;

            .main_left_cnt {
                width: 100%;
                height: calc(100% - 1rem);
                margin-top: 1rem;
                display: inline-flex;
                flex-flow: row wrap;
                justify-content: space-around;
                position: relative;
                .bz_div {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    color: #fff;
                    font-size: 0.7rem;
                    text-align: center;
                    transform: translate(-50%, 0);
                }
                .echarts {
                    width: 100%;
                    height: 100%;
                }

                .tanzhonghe {
                    width: 25%;
                    background: url("../../../assets/image/mainIndex/tanzhonghe.png") no-repeat;
                    background-size: 100% auto;
                    background-position: center;
                    position: relative;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    color: #fff;

                    .tzh_div {
                        width: 100%;
                        font-size: 0.65rem;
                        height: 0.8rem;
                        line-height: 0.8rem;
                    }
                }

                .main_left_byq {
                    width: 100%;
                    height: 70%;
                    margin-top: 10%;
                    background: url("../../../assets/image/mainIndex/bianyaqi.png") no-repeat;
                    background-size: auto 100%;
                    background-position: center;
                    position: relative;

                    div {
                        position: absolute;
                        color: #fff;
                        font-size: 0.7rem;
                    }
                }

                .cdz_div {
                    width: 50%;
                    height: 50%;
                    display: inline-flex;
                    box-sizing: border-box;
                    padding: 1rem 0 1rem 0.6rem;
                    align-items: center;

                    img {
                        width: 3.8rem;
                        height: 3.8rem;
                    }

                    .cdz_div_cnt {
                        height: 3.8rem;
                        color: #fff;
                        font-size: 0.8rem;
                        flex: 1;
                        display: inline-flex;
                        flex-flow: column wrap;
                        justify-content: space-around;
                        text-align: left;
                        margin-left: 0.2rem;
                        div:last-child i {
                            font-size: 0.9rem;
                        }
                    }
                }
            }
            .cdl_select {
                width: 100%; 
                display: inline-flex;
                align-items: center;
                margin-top: 1.5rem;
                color: #fff;
                justify-content: center;
                cursor: pointer;
                .cdl_title {
                    width: 3.5rem;
                    height: 1.2rem;
                    line-height: 1.2rem;
                }
                .title_us {
                    background: url("../../../assets/image/mainIndex/index_us.png") no-repeat;
                    background-size: 100% 100%;
                }
                .title_s {
                    background: url("../../../assets/image/mainIndex/index_s.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
            .cdz_pad {
                box-sizing: border-box;
              //  padding: 0.6rem;
            }

            .left1-content {
                display: flex;
                height: 8rem;
                width: 100%;
                font-size: 0.8rem;
                padding: 0.2rem 0.6rem;
                box-sizing: border-box;
                color: #fff;

                .left1-content-item {
                    flex: 1;

                    .left1-item-title {
                        height: 3rem;
                        margin-bottom: 1rem;

                        img {
                            width: 3rem;
                            height: 3rem;
                        }
                    }

                    .left1-item-content {
                        .left1-item-content-item {
                            height: 1.6rem;
                            text-align: center;
                            padding-left: 0rem;
                            box-sizing: border-box;

                            img {
                                margin-right: 0.3rem;
                            }

                            span {
                                color: #5ae9ed;
                            }
                        }
                    }
                }
            }

            .left2-chart {
                width: 100%;
                height: 8rem;

                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }

            .left3-chart {
                width: 100%;
                height: 8rem;

                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }

            .right1-content {
                width: 100%;
                height: 7rem;
                padding: 0.5rem 2rem;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;

                .right1-item {
                    width: 6rem;
                    height: 6rem;
                    background: url("../../../assets/image/mainIndex/circle.png") no-repeat;
                    background-size: 100% 100%;
                    font-size: 0.8rem;

                    .right1-item-title {
                        color: #fff;
                        height: 3rem;
                        line-height: 4rem;
                    }

                    .right1-item-content {
                        color: #e1cd57;
                        line-height: 1rem;

                        span {
                            color: #fff;
                        }
                    }
                }
            }

            .right2-chart {
                width: 100%;
                height: 9rem;

                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }

            .right2-data {
                color: #7bc7f3;
                font-size: 0.8rem;
                height: 1rem;
                line-height: 1rem;
                font-weight: bold;
                margin-top: 0.4rem;

                span {
                    color: #a5cf8f;
                }
            }

            .right3-content {
                width: 100%;
                height: 8rem;
                padding: 0.5rem 2rem;
                box-sizing: border-box;
                font-size: 1rem;

                .right3-box {
                    width: 100%;
                    height: 4rem;
                    display: flex;

                    .right3-item {
                        width: 50%;
                        padding: 0.5rem;
                        box-sizing: border-box;
                        text-align: center;

                        .right3-item-title {
                            width: 100%;
                            line-height: 1.5rem;
                            color: #fff;
                        }

                        .right3-item-content {
                            width: 100%;
                            line-height: 1.5rem;
                            color: #73bae3;

                            span {
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        i {
            color: #00ffff;
        }
    }
}
</style>
